import { AuditLog } from "@myapp/contract";
import apiClient from "../../../shared/config/axios";

export const auditLogApi = {
  listByWorkOrder: (workOrderId: string) =>
    apiClient.get<AuditLog[]>("/audit-logs", { params: { workOrderId } }),
};
